/* globals console, module, require */
/* jshint camelcase:false, esversion:6, globalstrict:true */
'use strict';

const analytics = require('./googleAnalytics'), //require('universal-ga'),
    BackboneRadio = require('backbone.radio'),
    _ = require('lodash'),
    configuration = require('./configuration'),
    inChannel = BackboneRadio.channel('vaultInterface:in'),
    analyticsChannel = BackboneRadio.channel('analytics');

let initialized;

function AnalyticsRadio() {
    this.initialize();
}

AnalyticsRadio.prototype._loadAnalytics = function(data) {
    // console.log('_loadAnalytics');
    analytics.load(data);
};

AnalyticsRadio.prototype.initialize = function () {
    // set up global gtag function.
    analytics.initialize();

    // load analytics when receiving setHostContext. This is always safe due to the implementation of googleAnalytics.js. Subsequent calls just set user_properties.
    inChannel.on('setHostContext', _.bind(!configuration.disableAnalytics ? this._loadAnalytics : this.logTransmission, this));

    // if (!initialized && !configuration.disableAnalytics) { // singleton.
    //     analytics.initialize(configuration.gaClientId);
    // }
    analyticsChannel.on('pageview', _.bind(!configuration.disableAnalytics ? this.pageview : this.logTransmission, this));
    analyticsChannel.on('event', _.bind(!configuration.disableAnalytics ? this.event : this.logTransmission, this));
    // analyticsChannel.on('variable', _.bind(!configuration.disableAnalytics ? this.variable : this.logTransmission, this));
    initialized = true;
};

AnalyticsRadio.prototype.pageview = function (loc) {
    analytics.pageview(loc, loc);
};

AnalyticsRadio.prototype.event = function (event) {
    analytics.event(event.category, event.action, event.label);
};

// obsolete with GA4
// AnalyticsRadio.prototype.variable = function (variable) {
//     analytics.custom(variable.key, variable.value);
// };

AnalyticsRadio.prototype.logTransmission = function (o) {
    if (configuration.logAnalyticsRadio) {
        console.log(o);
    }
};

module.exports = AnalyticsRadio;
